import america from "./america";
import barra from "./barra";
import base from "./base";
import jec from "./jec";
import itajai from "./itajai";
import maracana from "./maracana";

export const themes = { america, barra, base, jec, itajai, maracana };
